/*
 * Restores deferred bundle-drawer accordions (snippets/yap-bdl-accs-deferred.liquid) when a drawer opens.
 *
 * The product template opens a bundle drawer by setting aria-hidden="false" on [data-yap-bdl-drawer]; this watches
 * that attribute, swaps the inert template back into real markup, and repeats the two things the template's own
 * script does for accordions at load time (which ran before this content existed): drop the duplicate
 * "Description" item and bind the open/close toggles.
 */
(function () {
  if (window.yapBdlAccsLazy) return;
  window.yapBdlAccsLazy = true;

  function bindAccordion(acc) {
    var head = acc.querySelector('[data-yap-acc-toggle]');
    if (!head) return;
    head.addEventListener('click', function () {
      var open = acc.classList.toggle('is-open');
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function materialize(drawer) {
    if (!drawer) return;
    drawer.querySelectorAll('[data-yap-bdl-accs-deferred]').forEach(function (holder) {
      var tpl = holder.querySelector('script[data-yap-bdl-accs-tpl]');
      holder.removeAttribute('data-yap-bdl-accs-deferred');
      if (!tpl) return;
      var html = tpl.textContent.replace(/<\\\/script/gi, '</script');
      tpl.replaceWith(document.createRange().createContextualFragment(html));

      holder.querySelectorAll('.yap-acc--bdl').forEach(function (acc) {
        var title = acc.querySelector('.yap-acc-title');
        if (title && title.textContent.trim().toLowerCase() === 'description') acc.remove();
      });
      holder.querySelectorAll('[data-yap-acc]').forEach(bindAccordion);
    });
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.target.getAttribute('aria-hidden') === 'false') materialize(mutation.target);
    });
  });

  function watch() {
    document.querySelectorAll('[data-yap-bdl-drawer]').forEach(function (drawer) {
      if (drawer.dataset.yapBdlAccsWatched) return;
      drawer.dataset.yapBdlAccsWatched = '1';
      observer.observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
      // A drawer can already be open on load (e.g. after a notify-me form post re-opens it).
      if (drawer.getAttribute('aria-hidden') === 'false') materialize(drawer);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
